import React from 'react';
import { TFrontendConfigurationItem } from 'entries/common/widgets/context';
import { FrontendConfigurationCheckboxItem } from './frontend-configuration-checkbox-item';

type TProps = {
  checkboxes: TFrontendConfigurationItem[];
};

export const FrontendConfigurationChackboxes = ({ checkboxes }: TProps) => (
  <>
    {checkboxes.map(el => (
      <FrontendConfigurationCheckboxItem checkbox={el} key={`${el.name}`} />
    ))}
  </>
);
